import { render, staticRenderFns } from "./BrandedCardCollection.vue?vue&type=template&id=76683528&scoped=true&"
import script from "./BrandedCardCollection.vue?vue&type=script&lang=js&"
export * from "./BrandedCardCollection.vue?vue&type=script&lang=js&"
import style0 from "./BrandedCardCollection.vue?vue&type=style&index=0&id=76683528&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76683528",
  null
  
)

export default component.exports